import { handleActions } from 'redux-actions';
import {
  updatePendingAutoTieoutTBStep,
} from 'store/actions/trial-balance/trial-balance-action';

const DEFAULT = '';

export default handleActions(
  {
    [updatePendingAutoTieoutTBStep]: (state, { payload }) => {
      return payload;
    }
  },
  DEFAULT,
);
